<h1 mat-dialog-title>

    <b> Datos Convenio para confirmar Codeudor</b></h1>
<br/>
<form #convenioValidaForm=ngForm>

    <dialog-content>
        <p>
            <form-field appearance="outline" class="mat-input">
                <mat-label> Solicitante </mat-label>

                <mat-option>{{data.rutUsuario}} {{data.nombreUsuario}} {{data.apellidoUsuario}}</mat-option>

            </form-field>
        </p>
        <p *ngIf="this.convenio.idCarga > 0">
            <form-field appearance="outline" class="mat-input">
                <label> Beneficiario </label>
                <br/> {{this.convenio.nombreCarga}} ({{this.convenio.rutCarga}})

            </form-field>
        </p>
        <p>
            <form-field appearance="outline" class="mat-input">
                <mat-label> Monto Solicitado </mat-label>

                <mat-option> {{data.montoSolicitado}} </mat-option>

            </form-field>
        </p>
        
        <p *ngIf='data.proveedor !== undefined'> 
            <form-field appearance="outline" class="mat-input">
                <mat-label> Proveedor </mat-label>
                <mat-option> {{data.proveedor.nombreProveedor}}</mat-option>
            </form-field>
        </p>
        <p>

            <form-field appearance="outline" class="mat-input">
                <mat-label> Número de Presupuesto</mat-label>
                <mat-option> {{data.numPresupuesto}} </mat-option>
            </form-field>

        </p>

        <p>
            <form-field appearance="outline" class="mat-input">
                <mat-label> Región </mat-label>

                <select class="form-control" id="idRegion" name="idRegion" disabled [(ngModel)]="data.region" #idRegion="ngModel">

                    <option  *ngFor="let region of this.regiones" value="{{region.id}}">
                        {{region.nombre}}
                    </option>
                </select>

            </form-field>
        </p>
        <p>
            <form-field appearance="outline" class="mat-input">
                <mat-label> Cantidad Cuotas </mat-label>
                <mat-option> {{data.descripcionCantidadCuotas}} </mat-option>
            </form-field>
        </p>


        <p *ngIf="data.editable == true">
            <form-field appearance="outline" class="mat-input">
                <mat-label> Adjuntar Cédula de Identidad (FRONTAL) </mat-label>
                <div class="col-lg-6">
                    <input #archivo [(ngModel)]="convenio.archivoTest" type="file" class="form-control-file" name="archivo" (change)="seleccionaArchivo($event,1)" required accept="application/pdf, image/jpeg, image/jpg, image/png">
                </div>
            </form-field>
        </p>

        <p *ngIf="data.editable == true">
            <form-field appearance="outline" class="mat-input">
                <mat-label> Adjuntar Cédula de Identidad (POSTERIOR) </mat-label>
                <div class="col-lg-6">
                    <input  #archivo2 type="file" [(ngModel)]="convenio.archivoTest2" class="form-control-file" name="archivo2" (change)="seleccionaArchivo($event, 2)" required accept="application/pdf, image/jpeg, image/jpg, image/png">
                </div>
            </form-field>
        </p>
        
    </dialog-content>
</form>
<br/>
<mat-dialog-actions>
    <div *ngIf="data.editable == true">
        <button mat-button class="mat-raised-button btn-success" (click)="onAceptarClick()">
            <i class ="fa fa-check"> </i> Aceptar
        </button>
        <button mat-button class="mat-raised-button btn-danger" (click)="onRechazarClick()">
            <i class ="fa fa-times"> </i> Rechazar
        </button>
        <button mat-button class="mat-raised-button btn-dark" (click)="onCancelarClick()">
            <i class = "fa fa-trash"> </i> Salir
        </button>
    </div>
    <div *ngIf="data.editable == false">

        <button mat-button class="mat-raised-button btn-dark" (click)="onCancelarClick()">
            <i class = "fa fa-trash"> </i> Salir
        </button>
    </div>
</mat-dialog-actions>